@if ((this.groupId || organizationAverageId === shopId) && shopIds && shopIds.length > 0) {
  <div
    class="text-base leading-base text-primary underline cursor-pointer"
    (click)="window.innerWidth < mobileMaxWidth ? openDialog() : menuTrigger.openMenu()"
  >
    View included shops.
  </div>
  <div
    [matMenuTriggerFor]="window.innerWidth >= mobileMaxWidth ? includedShopsMenu : null"
    #menuTrigger="matMenuTrigger"
  ></div>
  <mat-menu
    #includedShopsMenu="matMenu"
    [hasBackdrop]="true"
    backdropClass="mg-menu-backdrop"
    class="mg-filter-menu"
  >
    <div class="w-[390px] p-lg md:p-base" (click)="$event.stopPropagation()">
      <mg-included-shops
        [shopsList]="shopsList"
        pillSize="s"
        (canceld)="menuTrigger.closeMenu()"
      ></mg-included-shops>
    </div>
  </mat-menu>
}
